import { jsx as _jsx } from "react/jsx-runtime";
// hs-private is styleNamespace configured in webpack.config.js for LayoutBuilderUI,
// This is a classname that is required to enable styled-components on a component and it's children.
export const NAMESPACE_ENABLE = 'hs-private';
export const NAMESPACE_CLASS = `${NAMESPACE_ENABLE} hubspot`;
export const NamespaceWrapper = ({
  children,
  use: Element = 'span'
}) => {
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(Element, {
    className: NAMESPACE_CLASS,
    children: children
  });
};